
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    Menu: () => import("@/components/client/Menu.vue"),
    AdminMenu: () => import("@/components/admin/Menu.vue"),
    CompanySelect: () => import("@/components/client/CompanySelect.vue")
  }
})
export default class Header extends Vue {
  @Prop(Boolean) readonly isRouteAdmin!: boolean;

  async logout() {
    await (this.$root as any).logout();
  }

  getBrandName() {
      const type = this.$store.state.business ? this.$store.state.business.type_id : 1;
      switch (type) {
         case 2:
            return "Facility Marketplace";
        case 1:
        default:
            return "";
    }
  }
}
